'use client';

import {usePathname, useRouter} from 'next/navigation';
import {map2Line, moreFill, share2Line} from 'src/utils/icons';
import ListContextMenu from './lists/ListContextMenu';
import isListEditable from 'src/utils/isListEditable';
import PlacesSortSelect from './PlacesSortSelect';
import ShareSheet from './ShareSheet';
import BaseButton from './BaseButton';
import Dropdown from './Dropdown';

type Props = {
  sortId: string;
  list: HumboList;
  session: IronSession | null;
};

const ListButtonsRow = ({sortId, list, session}: Props) => {
  const router = useRouter();
  const pathname = usePathname();

  const isEditable = isListEditable(list, session);

  const setSortId = (sortId: string) => {
    router.push(`${pathname}?sortId=${sortId}`);
  };

  return (
    <>
      <div className="flex items-center w-full mb-6">
        <BaseButton
          buttonVariant="primary"
          icon={map2Line}
          label="Show on map"
          href={`/${list.user?.nameId}/lists/${list.nameId}/map`}
        />

        <div className="grow" />

        <div className="flex items-center gap-3">
          <PlacesSortSelect sortId={sortId} onChange={setSortId} />

          <Dropdown items={[{component: <ShareSheet key={0} />}]}>
            <BaseButton
              buttonVariant="text"
              aria-label="Share"
              icon={share2Line}
              label="Share"
              className="max-[600px]:hidden"
            />
          </Dropdown>

          {isEditable ? (
            <ListContextMenu list={list} session={session}>
              <BaseButton icon={moreFill} buttonVariant="text" />
            </ListContextMenu>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default ListButtonsRow;
